import React, { useEffect, useRef, useState } from "react";
import "./Signupnew.scss";
import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
import DesktopSignupPopup from '../../components/DesktopSignupModal/DesktopSignupModal'
import SigninScreen from "./SigninScreen";
import OtpScreenNew from "./OtpScreenNew";
import UpdateUserDetails from "./UpdateUserDetails";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from "../../common/constants";
import { deleteCookie, getCookie } from "../../helper/cookieHelper";

// import SignInForm from "../SignInForm/SignInForm";
interface signinprops {
  isOpen: any;
  onClose: any;
  setSigninOrOtp?: React.Dispatch<React.SetStateAction<string>>
  signInPopupDesktop?: boolean

}
const signInScreens = {
  SIGNIN: "signin",
  OTP: "otp",
  UPDATE_USER: "EditProfile"
}

const SiginInContainer: React.FC<signinprops> = ({ isOpen, onClose, setSigninOrOtp, signInPopupDesktop }) => {
  const verifyOtpSuccess = useSelector((state: any) => state.auth.verifyOtpSuccess);
  const verifyOtpMessage = useSelector((state: any) => state.auth.verifyOtpMessage);
  const countryData = useSelector((state: any) => state.user.countryData);
  const [data, setdata] = useState<any>({});

  // Use countryData.code instead of separate countryCode state
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile)

  const getOtpLoading = useSelector((state: any) => state.auth.getOtpLoading)
  const getOtpSuccess = useSelector((state: any) => state.auth.getOtpSuccess);
  const getOtpFailure = useSelector(
    (state: any) => state.auth.getOtpFailure
  );

  const userData = useSelector((state: any) => state.auth.userData) || getCookie(USER_DETAILS);
  // console.log("userDataCookie 4",userData)        
  // const userDataLocal = useSelector((state: any) => state.auth.userData)|| JSON.parse(localStorage.getItem(USER_DETAILS)||"{}");
  useEffect(() => {
    if (getOtpSuccess) {
      setCurrentScreen(signInScreens?.OTP)
    }
  }, [getOtpSuccess])

  useEffect(() => {
    if (!userData?.customerId) {
      setCurrentScreen(signInScreens?.SIGNIN)
    }
  }, [userData])


  useEffect(() => {
    // Only auto-close if the component is actually open AND userData exists in cookies (not just Redux state)
    // After 403/401, cookies are deleted, so getCookie will return null even if Redux state has old data
    const userDataFromCookie = getCookie(USER_DETAILS);
    if (verifyOtpSuccess && isOpen && userDataFromCookie?.customerId) {
      if (!userDataFromCookie?.mobilePhone || !userDataFromCookie?.firstName || !userDataFromCookie?.email) {
        setCurrentScreen(signInScreens?.UPDATE_USER)
      } else {
        setCurrentScreen(signInScreens?.SIGNIN)
        //  setCurrentScreen(signInScreens?.UPDATE_USER)
        onClose()
      }
    }
  }, [verifyOtpSuccess, isOpen])




  const [currentScreen, setCurrentScreen] = useState("signin");
  const [currentPage, setCurrentPage] = useState("signin");

  useEffect(() => {
    if (currentScreen === signInScreens.OTP) {
      setSigninOrOtp && setSigninOrOtp("Enter OTP");
    } else if (currentScreen === signInScreens.UPDATE_USER) {
      setSigninOrOtp && setSigninOrOtp("Sign Up");
    } else {
      setSigninOrOtp && setSigninOrOtp("Sign In");
    }

  }, [currentScreen])

  useEffect(() => {
    const lockScroll = () => {
      document.body.classList.add("no-scroll");
      document.documentElement.classList.add("no-scroll");
    };

    const unlockScroll = () => {
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");
    };

    if (currentPage === signInScreens?.SIGNIN || currentPage === signInScreens?.OTP || currentPage === signInScreens?.UPDATE_USER) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => {
      unlockScroll();
    };
  }, [currentPage]);

  if (!isOpen) return null;

  const handleSignInClose = () => {
    onClose();
  }

  const handleSignSubmit = () => {
    setCurrentPage(signInScreens?.OTP)
  }

  const handleOtpClose = (forceClose?: boolean) => {
    if (forceClose) onClose();
    if (verifyOtpMessage?.body?.customerDetails) {
      //  setCurrentScreen(signInScreens?.UPDATE_USER );
      onClose();
    } else {
      setCurrentScreen(signInScreens?.UPDATE_USER);
    }
  }
  const hanldeDesktopPopupSignUP = (shouldClearAuth = true) => {
    onClose();
    if (shouldClearAuth) {
      deleteCookie(USER_ID);
      deleteCookie(USER_DETAILS);
      deleteCookie(ACCESS_TOKEN);
    } 
    //  setCurrentScreen(signInScreens.SIGNIN);  
  }



  const handleVerifySubmit = () => {
    if (userData?.customerId) {
      setCurrentScreen(signInScreens.SIGNIN)
      onClose()
    } else {
      setCurrentScreen(signInScreens.UPDATE_USER)
    }
  }


  return (
    <>
      {/* {currentScreen === signInScreens?.SIGNIN? <SigninScreen handleOnSubmit={handleSignInClose} onClose={handleSignInClose} /> : (currentScreen === signInScreens?.OTP ? <OtpScreenNew setCurrentScreen={setCurrentScreen} onClose={handleOtpClose} /> : (currentScreen === signInScreens?.UPDATE_USER ? <UpdateUserDetails onClose={onClose} /> : null))} */}

      <div className={signInPopupDesktop ? "user-Signin-container-overlay" : ""}>
        <div className={signInPopupDesktop ? currentPage === signInScreens?.OTP ? "user-otp-container" : (currentPage === signInScreens?.UPDATE_USER) ? "user-DesktopView-container" : "user-Signin-container" : "usercontainer-checkoutpage"}>
          {signInPopupDesktop && <CancelIcon className="close-btnZa-Desktop-signup"
            onClick={() => {
              if (currentScreen === signInScreens?.SIGNIN) {
                handleSignInClose();
              } else if (currentScreen === signInScreens?.OTP) {
                handleOtpClose(true);
              } else {
                hanldeDesktopPopupSignUP();
              }
            }} />}

          {
            currentPage === signInScreens?.SIGNIN ?
              <SigninScreen
                handleOnSubmit={handleSignSubmit}
                onClose={handleSignInClose}
                isMobile={isMobile}
                signInPopupDesktop={signInPopupDesktop}
                setdata={setdata}
              />
              //  <UpdateUserDetails onClose={onClose} countryData={countryData} data={data} isMobile={isMobile} signInPopupDesktop={signInPopupDesktop} setCurrentPage={setCurrentPage} />
              // <DesktopSignupPopup isOpen={signInPopupDesktop} onClose={hanldeDesktopPopupSignUP} setCurrentPage={setCurrentPage} />

              :
              currentPage === signInScreens?.OTP ?
                <OtpScreenNew
                  handleVerifySubmit={handleVerifySubmit}
                  onClose={handleOtpClose}
                  setCurrentPage={setCurrentPage}
                  userData={userData}
                  isMobile={isMobile}
                  signInPopupDesktop={signInPopupDesktop}
                  countryData={countryData}
                  data={data}
                /> :
                currentPage === signInScreens?.UPDATE_USER ?
                  signInPopupDesktop ?
                    <DesktopSignupPopup
                      isOpen={signInPopupDesktop}
                      onClose={() => hanldeDesktopPopupSignUP(false)}
                      setCurrentPage={setCurrentPage}
                      data={data}
                    /> :
                    <UpdateUserDetails
                      onClose={onClose}
                      countryData={countryData}
                      data={data}
                      isMobile={isMobile}
                      signInPopupDesktop={signInPopupDesktop}
                      setCurrentPage={setCurrentPage}
                    /> : <></>
          }

        </div>
      </div>

    </>
  );
};

export default SiginInContainer;
